export function socketBuilder(config) {
	return function connect(extension) {
		let connection = window.io.connect(config.socketUrl, {
			transports: ["websocket", "polling"],
			query: {token: localStorage.token}
		});

		function onConnect() {
			console.info("SOCKET: connected!");
			connection.emit("setCrmListener", {
				name: "crm",
				number: extension
			});
		}

		connection.on("connect", onConnect);
		connection.on("reconnect", onConnect);
		connection.on("connect_error", (e) => console.warn(e));
		return connection;
	};
}
